import {Select as AntdSelect} from 'antd';

const Select = (props) => <AntdSelect {...props}/>;
export default Select;

Select.Option = AntdSelect.Option;
Select.OptGroup = AntdSelect.OptGroup;
